import { useTranslation } from 'react-i18next';

const useCheckTrad = (keyTrad: string, options?: { [key: string]: string }) => {
  const { t, i18n } = useTranslation();

  if (i18n.exists(keyTrad, { options })) {
    return t(keyTrad, options);
  }

  return '';
};

export default useCheckTrad;
